<p>{{ varA }}</p>

<button (click)="test()">Test</button>
<button (click)="back()">Back</button>
